import { ProposalFilter } from "app/utils/types";
import { getHeaderText } from "./projectionSDColumnJson";

export const fundingColumnJson: any = (selectedFundingData: any, selectedChartFilter: any) => [
  {
    field: selectedChartFilter || "policyYear",
    header: getHeaderText(selectedChartFilter),
    frozen: true,
  },
  {
    field: "annualLifePremium",
    header: "Annual Life Premium",
    style: { opacity: !selectedFundingData?.includes(ProposalFilter.LIFE) ? 0.5 : 1 },
    formatter: (value: any) =>
      new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value),
  },
  {
    field: "annualDisabilityPremium",
    header: "Annual Disability Premium",
    style: { opacity: !selectedFundingData?.includes(ProposalFilter.DISABILITY) ? 0.5 : 1 },
    formatter: (value: any) =>
      new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value),
  },
  {
    field: "totalAnnualPremium",
    header: "Total Annual Premium",
    // style: { opacity: isOpacity ? 0.5 : 1, textAlign: "center" },
    formatter: (value: any) =>
      new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value),
  },
  {
    field: "annualAdminFees",
    header: "Plan Fees",
    style: { opacity: !selectedFundingData?.includes(ProposalFilter.ADMIN_FEES) ? 0.5 : 1 },
    formatter: (value: any) =>
      new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value),
  },
  {
    field: "planOriginationFees",
    header: "Origination Fees",
    style: {
      opacity: !selectedFundingData?.includes(ProposalFilter.PLAN_ORIGINATION_FEES) ? 0.5 : 1,
    },
    formatter: (value: any) =>
      new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value),
  },
  {
    field: "totalPlanCosts",
    header: "Total Plan Costs",
    formatter: (value: any) =>
      new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value),
  },
];
